import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { BehaviorSubject }    from 'rxjs'; 
import { ApiService } from '../core/api.service';
import { AuthService } from "../core/auth.service";
import { UserLogin } from "../../models/cms/user-login";

@Injectable()
export class HeaderService 
{
  constructor
    (
      public _api: ApiService,
      private authService: AuthService
    ) {
  }

  toShowQuickRegistration: boolean = false;

  // Observable source of logged in user
  private loginInfo: UserLogin = this.authService.GetData();
  private loggedInUser = new BehaviorSubject<UserLogin>(this.loginInfo);

  getLoggedInUser(): Observable<UserLogin> {
    return this.loggedInUser.asObservable();
  }

  setLoggedInUser(user: UserLogin)
  {
    this.loggedInUser.next(user);
  }

  setToShowQuickRegistration(toShow: boolean)
  {
    this.toShowQuickRegistration = toShow;
  }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/header.service.ts